<template>
	<!-- Wrapper -->
	<div class="pt4">
		<!-- Field -->

		<!-- Using Object list -->
		<div class="xs-12 fs4 fw7 lh125 p1 mt2">{{ $t("fields") }}</div>
		<j-input-object-list size="medium" v-model="value" />
	</div>
</template>

<script>
import JInputObjectList from "@/components/JInputObjectList"

export default {
	name: "UpdateAddressInput",
	components: {
		JInputObjectList
	},
	props: {
		value: {
			required: true,
			default: null
		}
	}
}
</script>
